import Immutable from 'immutable';
import { createSelector } from 'reselect';
import {
  selectAuthorNoteEntities,
  selectReviewEntities,
  selectMediaSummaryEntities,
  selectRelatedAuthorEntities,
  selectExcerptEntities,
  selectOnlineResourcesEntities
} from '../EntitiesSelector';

const getAuthorNoteId = state => state.getIn(['bibs', 'evaluation', 'authorNote', 'id']) || '';
const getReviewSummary = state => state.getIn(['bibs', 'evaluation', 'reviews'], Immutable.Map());
const getMediaSummaryId = state => state.getIn(['bibs', 'evaluation', 'mediaSummary', 'id']) || '';
const getRelatedAuthors = state => state.getIn(['bibs', 'evaluation', 'relatedAuthors', 'items'], Immutable.List());
const getExcerptId = state => state.getIn(['bibs', 'evaluation', 'excerpt', 'id']) || '';
const getOnlineResources = state => state.getIn(['bibs', 'evaluation', 'externalResources', 'items'], Immutable.List());

export const selectAuthorNoteForCurrentBib = createSelector(
  [getAuthorNoteId, selectAuthorNoteEntities],
  (authorNoteId, authorNoteEntities) => authorNoteEntities.getIn([authorNoteId.toString(), 'notes'], '') ?? ''
);

export const selectReviewsForCurrentBib = createSelector(
  [selectReviewEntities, getReviewSummary],
  (reviewEntities, reviewSummary) =>
    Immutable.Map({
      totalReviews: reviewSummary.get('totalReviews', 0),
      items: reviewSummary.get('items', Immutable.List()).map(id => reviewEntities.get(id.toString()))
    })
);

export const selectMediaSummaryForCurrentBib = createSelector(
  [getMediaSummaryId, selectMediaSummaryEntities],
  (mediaSummaryId, mediaSummaryEntities) => mediaSummaryEntities.getIn([mediaSummaryId.toString(), 'contents'])
);

export const selectRelatedAuthorsForCurrentBib = createSelector(
  [getRelatedAuthors, selectRelatedAuthorEntities],
  (relatedAuthorIds, relatedAuthorEntities) =>
    relatedAuthorIds.map(relatedAuthorId => relatedAuthorEntities.get(relatedAuthorId.toString()))
);

export const selectExcerptsForCurrentBib = createSelector(
  [getExcerptId, selectExcerptEntities],
  (excerptId, excerptEntities) => excerptEntities.getIn([excerptId.toString(), 'excerpt'])
);

export const selectOnlineResourcesForCurrentBib = createSelector(
  [getOnlineResources, selectOnlineResourcesEntities],
  (onlineResourceIds, onlineResourceEntities) =>
    onlineResourceIds.map(onlineResourceId => onlineResourceEntities.get(onlineResourceId.toString()))
);
